// extracted by mini-css-extract-plugin
export default {"alertModal":"SavedSearchAlertModal_alertModal__WzhaY","container":"SavedSearchAlertModal_container__UCEIp","detail":"SavedSearchAlertModal_detail__TOB0c"};